import HeroWithLogo25 from "./heroWithLogo25";

export default HeroWithLogo25;
